export type Language = 'en' | 'hi' | 'mr'

export const translations = {
  en: {
    // Header
    portalName: 'Citizen Registration Portal | Government of India',
    helpline: '📞 ०२०-२५५०१००० | ✉️ mayor@punecorporation.org',
    brandName: 'Pune Pratham',
    brandSubtitle: 'Mayor\'s Initiative',
    navHome: 'Home',
    navAbout: 'About',
    navEvents: 'Events',
    navContact: 'Contact',
    navComplaints: 'Complaints',
    navRegistration: 'Registration',
    navFeedback: 'Feedback',
    navAdminLogin: 'Admin Login',
    accessibility: 'Accessibility',
    language: 'Language',

    // Hero Section
    officialPortal: '🏛️ Official Citizen Registration Portal',
    heroTitle: 'Join Us',
    heroSubtitle: 'Register your details securely. Get your unique Registration ID instantly. Empowering citizens through digital governance.',
    raiseComplaint: 'Raise Complaint',
    trackComplaint: 'Track Complaint',
    citizensRegistered: 'Citizens Registered',
    totalComplaints: 'Total Complaints',
    resolvedComplaints: 'Resolved Complaints',
    secureRecords: 'Secure Records',
    verifiedEntries: 'Verified Entries',

    // Registration Form Page
    citizenRegForm: 'Join Us',
    fillDetails: 'Fill in your details below to get your unique Registration ID',

    // Registration Form
    personalInfo: 'Personal Information',
    firstName: 'First Name',
    middleName: 'Middle Name',
    lastName: 'Last Name',
    gender: 'Gender',
    selectGender: 'Select Gender',
    male: 'Male',
    female: 'Female',
    other: 'Other',
    bloodGroup: 'Blood Group',
    selectBloodGroup: 'Select Blood Group',
    contactDetails: 'Contact Details',
    mobileNumber: 'Mobile Number',
    whatsappNumber: 'WhatsApp Number',
    sameAsMobile: 'Same as Mobile Number',
    addressInfo: 'Address Information',
    fullAddress: 'Full Address',
    fullAddressPlaceholder: 'Enter complete address with house no., street, landmark...',
    state: 'State',
    district: 'District',
    wardNumber: 'Ward Number',
    wardPlaceholder: 'Enter ward number',
    pincode: 'Pincode',
    pincodePlaceholder: '6-digit pincode',
    birthInfo: 'Birth Information',
    dob: 'Date of Birth',
    age: 'Age (Auto-calculated)',
    ageSelect: 'Select DOB to calculate age',
    years: 'Years',
    ageNote: 'Age is calculated automatically from date of birth',
    submitRegistration: 'Submit Registration',
    submittingRegistration: 'Submitting Registration...',
    requiredNote: '* Required fields. Your data is secured and encrypted.',
    registrationSuccessful: 'Registration Successful!',
    registrationSuccessMsg: 'Your citizen registration has been completed successfully.',
    yourRegistrationId: 'Your Registration ID',
    saveIdNote: 'Please save your Registration ID for future reference.',
    registerAnother: 'Register Another Citizen',
    required: 'Required',

    // Complaint Form
    registerGrievance: 'Register a Grievance',
    grievanceSubtitle: 'Please provide detailed information to help us resolve your issue.',
    verifyPhone: 'Verify Phone Number',
    verifyPhoneSubtitle: 'Please enter your registered mobile number to proceed.',
    mobileNo: 'Mobile Number',
    tenDigit: '10-digit number',
    continue: 'Continue',
    numberNotRegistered: 'Number Not Registered',
    numberNotRegisteredMsg: 'Your phone number is not registered. Please register first to raise a complaint.',
    goToRegistration: 'Join Us',
    tryAnotherNumber: 'Try Another Number',
    citizenDetails: 'Citizen Details (Auto-filled)',
    emailAddress: 'Email Address',
    fullAddressLabel: 'Full Address',
    wardNo: 'Ward Number',
    complaintInfo: 'Complaint Information',
    complaintTitle: 'Complaint Title',
    complaintTitlePlaceholder: 'e.g., Water Leakage, Road Damage',
    maxChars: 'Maximum 150 characters',
    complaintDescription: 'Complaint Description',
    descPlaceholder: 'Describe the issue in detail...',
    minMaxChars: 'Minimum 30, Maximum 3000 characters',
    priority: 'Priority',
    medium: 'Medium',
    high: 'High',
    low: 'Low',
    docUpload: 'Document Upload (Optional)',
    clickOrDrag: 'Click or drag files to upload',
    supportedFormats: 'Supported: PDF, JPG, PNG (Max 10MB per file)',
    submitComplaint: 'Submit Complaint',
    complaintSuccess: 'Complaint Submitted Successfully',
    complaintNo: 'Complaint Number',
    date: 'Date',
    currentStatus: 'Current Status',
    trackComplaintBtn: 'Track Complaint',

    // Track Complaint
    trackGrievance: 'Track Your Grievance',
    trackSubtitle: 'Enter your registered mobile number to check the status',
    enterMobile: 'Enter 10-digit mobile number',
    search: 'Search',
    yourComplaints: 'Your Complaints',
    description: 'Description',
    priorityLabel: 'Priority',
    address: 'Address',
    attachments: 'Attachments',
    viewFile: 'View File',
    department: 'Department',
    notAssigned: 'Not Assigned',
    statusTimeline: 'Status Timeline',
    complaintDetails: 'Complaint Details',
    noComplaints: 'No complaints found for this mobile number.',

    // Footer
    footerDesc: 'Citizen Registration & Management System. Secure. Scalable. Government-Grade.',
    quickLinks: 'Quick Links',
    support: 'Support',
    supportDesc: 'For technical support, contact your district administrator.',
    footerCopy: '© {year} Pune Pratham. All rights reserved. | Mayor\'s Initiative',

    // Accessibility Panel
    accessibilityOptions: 'Accessibility Options',
    biggerText: 'Bigger Text',
    smallerText: 'Smaller Text',
    textSpacing: 'Text Spacing',
    lineHeight: 'Line Height',
    dyslexiaFriendly: 'Dyslexia Friendly',
    adhdMode: 'ADHD Mode',
    saturation: 'Saturation',
    lightDark: 'Light-Dark',
    invertColors: 'Invert Colors',
    highlightLinks: 'Highlight Links',
    textToSpeech: 'Text To Speech',
    screenReader: 'Screen Reader',
    cursor: 'Cursor',
    pauseAnimation: 'Pause Animation',
    hideImages: 'Hide Images',
    resetAllSettings: 'Reset All Settings',
    createdBy: 'Created by Pune Pratham',
  },

  hi: {
    // Header
    portalName: 'नागरिक पंजीकरण पोर्टल | भारत सरकार',
    helpline: '📞 ०२०-२५५०१००० | ✉️ mayor@punecorporation.org',
    brandName: 'पुणे प्रथम',
    brandSubtitle: 'महापौर की पहल',
    navHome: 'होम',
    navAbout: 'हमारे बारे में',
    navEvents: 'कार्यक्रम',
    navContact: 'संपर्क',
    navComplaints: 'शिकायतें',
    navRegistration: 'पंजीकरण',
    navFeedback: 'प्रतिक्रिया',
    navAdminLogin: 'एडमिन लॉगिन',
    accessibility: 'सुगम्यता',
    language: 'भाषा',

    // Hero Section
    officialPortal: '🏛️ आधिकारिक नागरिक पंजीकरण पोर्टल',
    heroTitle: 'हमसे जुड़ें',
    heroSubtitle: 'अपनी जानकारी सुरक्षित रूप से दर्ज करें। तुरंत अपनी विशिष्ट पंजीकरण आईडी प्राप्त करें। डिजिटल शासन के माध्यम से नागरिकों को सशक्त बनाना।',
    raiseComplaint: 'शिकायत दर्ज करें',
    trackComplaint: 'शिकायत ट्रैक करें',
    citizensRegistered: 'पंजीकृत नागरिक',
    totalComplaints: 'कुल शिकायतें',
    resolvedComplaints: 'समाधान की गई शिकायतें',
    secureRecords: 'सुरक्षित रिकॉर्ड',
    verifiedEntries: 'सत्यापित प्रविष्टियाँ',

    // Registration Form Page
    citizenRegForm: 'हमसे जुड़ें',
    fillDetails: 'अपनी विशिष्ट पंजीकरण आईडी प्राप्त करने के लिए नीचे अपनी जानकारी भरें',

    // Registration Form
    personalInfo: 'व्यक्तिगत जानकारी',
    firstName: 'पहला नाम',
    middleName: 'मध्य नाम',
    lastName: 'उपनाम',
    gender: 'लिंग',
    selectGender: 'लिंग चुनें',
    male: 'पुरुष',
    female: 'महिला',
    other: 'अन्य',
    bloodGroup: 'रक्त समूह',
    selectBloodGroup: 'रक्त समूह चुनें',
    contactDetails: 'संपर्क विवरण',
    mobileNumber: 'मोबाइल नंबर',
    whatsappNumber: 'व्हाट्सएप नंबर',
    sameAsMobile: 'मोबाइल नंबर के समान',
    addressInfo: 'पता जानकारी',
    fullAddress: 'पूरा पता',
    fullAddressPlaceholder: 'मकान नं., गली, लैंडमार्क सहित पूरा पता दर्ज करें...',
    state: 'राज्य',
    district: 'जिला',
    wardNumber: 'वार्ड संख्या',
    wardPlaceholder: 'वार्ड संख्या दर्ज करें',
    pincode: 'पिनकोड',
    pincodePlaceholder: '6 अंकों का पिनकोड',
    birthInfo: 'जन्म जानकारी',
    dob: 'जन्म तिथि',
    age: 'आयु (स्वतः गणना)',
    ageSelect: 'आयु गणना के लिए जन्म तिथि चुनें',
    years: 'वर्ष',
    ageNote: 'आयु जन्म तिथि से स्वचालित रूप से गणना की जाती है',
    submitRegistration: 'पंजीकरण जमा करें',
    submittingRegistration: 'पंजीकरण जमा हो रहा है...',
    requiredNote: '* आवश्यक फ़ील्ड। आपका डेटा सुरक्षित और एन्क्रिप्टेड है।',
    registrationSuccessful: 'पंजीकरण सफल!',
    registrationSuccessMsg: 'आपका नागरिक पंजीकरण सफलतापूर्वक पूर्ण हो गया है।',
    yourRegistrationId: 'आपकी पंजीकरण आईडी',
    saveIdNote: 'भविष्य के संदर्भ के लिए अपनी पंजीकरण आईडी सहेजें।',
    registerAnother: 'एक और नागरिक पंजीकृत करें',
    required: 'आवश्यक',

    // Complaint Form
    registerGrievance: 'शिकायत दर्ज करें',
    grievanceSubtitle: 'आपकी समस्या को हल करने में मदद के लिए विस्तृत जानकारी प्रदान करें।',
    verifyPhone: 'फ़ोन नंबर सत्यापित करें',
    verifyPhoneSubtitle: 'आगे बढ़ने के लिए अपना पंजीकृत मोबाइल नंबर दर्ज करें।',
    mobileNo: 'मोबाइल नंबर',
    tenDigit: '10 अंकों का नंबर',
    continue: 'जारी रखें',
    numberNotRegistered: 'नंबर पंजीकृत नहीं है',
    numberNotRegisteredMsg: 'आपका फ़ोन नंबर पंजीकृत नहीं है। शिकायत दर्ज करने के लिए पहले पंजीकरण करें।',
    goToRegistration: 'हमसे जुड़ें',
    tryAnotherNumber: 'दूसरा नंबर आजमाएं',
    citizenDetails: 'नागरिक विवरण (स्वतः भरा)',
    emailAddress: 'ईमेल पता',
    fullAddressLabel: 'पूरा पता',
    wardNo: 'वार्ड संख्या',
    complaintInfo: 'शिकायत जानकारी',
    complaintTitle: 'शिकायत का शीर्षक',
    complaintTitlePlaceholder: 'जैसे, पानी का रिसाव, सड़क क्षति',
    maxChars: 'अधिकतम 150 अक्षर',
    complaintDescription: 'शिकायत विवरण',
    descPlaceholder: 'समस्या का विस्तार से वर्णन करें...',
    minMaxChars: 'न्यूनतम 30, अधिकतम 3000 अक्षर',
    priority: 'प्राथमिकता',
    medium: 'मध्यम',
    high: 'उच्च',
    low: 'कम',
    docUpload: 'दस्तावेज़ अपलोड (वैकल्पिक)',
    clickOrDrag: 'फ़ाइलें अपलोड करने के लिए क्लिक करें या खींचें',
    supportedFormats: 'समर्थित: PDF, JPG, PNG (प्रति फ़ाइल अधिकतम 10MB)',
    submitComplaint: 'शिकायत जमा करें',
    complaintSuccess: 'शिकायत सफलतापूर्वक जमा हुई',
    complaintNo: 'शिकायत संख्या',
    date: 'तारीख',
    currentStatus: 'वर्तमान स्थिति',
    trackComplaintBtn: 'शिकायत ट्रैक करें',

    // Track Complaint
    trackGrievance: 'अपनी शिकायत ट्रैक करें',
    trackSubtitle: 'स्थिति जांचने के लिए अपना पंजीकृत मोबाइल नंबर दर्ज करें',
    enterMobile: '10 अंकों का मोबाइल नंबर दर्ज करें',
    search: 'खोजें',
    yourComplaints: 'आपकी शिकायतें',
    description: 'विवरण',
    priorityLabel: 'प्राथमिकता',
    address: 'पता',
    attachments: 'संलग्नक',
    viewFile: 'फ़ाइल देखें',
    department: 'विभाग',
    notAssigned: 'नियुक्त नहीं',
    statusTimeline: 'स्थिति समयरेखा',
    complaintDetails: 'शिकायत विवरण',
    noComplaints: 'इस मोबाइल नंबर के लिए कोई शिकायत नहीं मिली।',

    // Footer
    footerDesc: 'नागरिक पंजीकरण एवं प्रबंधन प्रणाली। सुरक्षित। स्केलेबल। सरकारी स्तर।',
    quickLinks: 'त्वरित लिंक',
    support: 'सहायता',
    supportDesc: 'तकनीकी सहायता के लिए, अपने जिला प्रशासक से संपर्क करें।',
    footerCopy: '© {year} पुणे प्रथम। सर्वाधिकार सुरक्षित। | महापौर की पहल',

    // Accessibility Panel
    accessibilityOptions: 'सुगम्यता विकल्प',
    biggerText: 'बड़ा टेक्स्ट',
    smallerText: 'छोटा टेक्स्ट',
    textSpacing: 'टेक्स्ट स्पेसिंग',
    lineHeight: 'लाइन हाइट',
    dyslexiaFriendly: 'डिस्लेक्सिया अनुकूल',
    adhdMode: 'ADHD मोड',
    saturation: 'संतृप्ति',
    lightDark: 'लाइट-डार्क',
    invertColors: 'रंग पलटें',
    highlightLinks: 'लिंक हाइलाइट',
    textToSpeech: 'टेक्स्ट से वाणी',
    screenReader: 'स्क्रीन रीडर',
    cursor: 'कर्सर',
    pauseAnimation: 'एनिमेशन रोकें',
    hideImages: 'छवियाँ छुपाएं',
    resetAllSettings: 'सभी सेटिंग्स रीसेट करें',
    createdBy: 'पुणे प्रथम द्वारा निर्मित',
  },

  mr: {
    // Header
    portalName: 'नागरिक नोंदणी पोर्टल | भारत सरकार',
    helpline: '📞 ०२०-२५५०१००० | ✉️ mayor@punecorporation.org',
    brandName: 'पुणे प्रथम',
    brandSubtitle: 'महापौरांचा उपक्रम',
    navHome: 'मुख्यपृष्ठ',
    navAbout: 'आमच्याबद्दल',
    navEvents: 'कार्यक्रम',
    navContact: 'संपर्क',
    navComplaints: 'तक्रारी',
    navRegistration: 'नोंदणी',
    navFeedback: 'अभिप्राय',
    navAdminLogin: 'प्रशासक लॉगिन',
    accessibility: 'प्रवेशयोग्यता',
    language: 'भाषा',

    // Hero Section
    officialPortal: '🏛️ अधिकृत नागरिक नोंदणी पोर्टल',
    heroTitle: 'आमच्यात सामील व्हा',
    heroSubtitle: 'तुमची माहिती सुरक्षितपणे नोंदवा. तात्काळ तुमची विशिष्ट नोंदणी आईडी मिळवा. डिजिटल शासनाद्वारे नागरिकांना सक्षम करणे.',
    raiseComplaint: 'तक्रार नोंदवा',
    trackComplaint: 'तक्रार ट्रॅक करा',
    citizensRegistered: 'नोंदणीकृत नागरिक',
    totalComplaints: 'एकूण तक्रारी',
    resolvedComplaints: 'सोडवलेल्या तक्रारी',
    secureRecords: 'सुरक्षित नोंदी',
    verifiedEntries: 'सत्यापित नोंदी',

    // Registration Form Page
    citizenRegForm: 'आमच्यात सामील व्हा',
    fillDetails: 'तुमची विशिष्ट नोंदणी आईडी मिळवण्यासाठी खाली तुमची माहिती भरा',

    // Registration Form
    personalInfo: 'वैयक्तिक माहिती',
    firstName: 'पहिले नाव',
    middleName: 'मधले नाव',
    lastName: 'आडनाव',
    gender: 'लिंग',
    selectGender: 'लिंग निवडा',
    male: 'पुरुष',
    female: 'महिला',
    other: 'इतर',
    bloodGroup: 'रक्तगट',
    selectBloodGroup: 'रक्तगट निवडा',
    contactDetails: 'संपर्क तपशील',
    mobileNumber: 'मोबाइल नंबर',
    whatsappNumber: 'व्हॉट्सअॅप नंबर',
    sameAsMobile: 'मोबाइल नंबर सारखाच',
    addressInfo: 'पत्ता माहिती',
    fullAddress: 'पूर्ण पत्ता',
    fullAddressPlaceholder: 'घर क्र., रस्ता, खुणाचिन्ह सह संपूर्ण पत्ता प्रविष्ट करा...',
    state: 'राज्य',
    district: 'जिल्हा',
    wardNumber: 'वार्ड क्रमांक',
    wardPlaceholder: 'वार्ड क्रमांक प्रविष्ट करा',
    pincode: 'पिनकोड',
    pincodePlaceholder: '6 अंकी पिनकोड',
    birthInfo: 'जन्म माहिती',
    dob: 'जन्म तारीख',
    age: 'वय (स्वयंचलित गणना)',
    ageSelect: 'वय मोजण्यासाठी जन्म तारीख निवडा',
    years: 'वर्षे',
    ageNote: 'वय जन्म तारखेवरून आपोआप मोजले जाते',
    submitRegistration: 'नोंदणी सादर करा',
    submittingRegistration: 'नोंदणी सादर होत आहे...',
    requiredNote: '* आवश्यक क्षेत्रे. तुमचा डेटा सुरक्षित आणि एन्क्रिप्टेड आहे.',
    registrationSuccessful: 'नोंदणी यशस्वी!',
    registrationSuccessMsg: 'तुमची नागरिक नोंदणी यशस्वीरित्या पूर्ण झाली आहे.',
    yourRegistrationId: 'तुमची नोंदणी आईडी',
    saveIdNote: 'भविष्यातील संदर्भासाठी तुमची नोंदणी आईडी जतन करा.',
    registerAnother: 'आणखी एक नागरिक नोंदवा',
    required: 'आवश्यक',

    // Complaint Form
    registerGrievance: 'तक्रार नोंदवा',
    grievanceSubtitle: 'तुमची समस्या सोडवण्यास मदत करण्यासाठी सविस्तर माहिती द्या.',
    verifyPhone: 'फोन नंबर सत्यापित करा',
    verifyPhoneSubtitle: 'पुढे जाण्यासाठी तुमचा नोंदणीकृत मोबाइल नंबर प्रविष्ट करा.',
    mobileNo: 'मोबाइल नंबर',
    tenDigit: '10 अंकी नंबर',
    continue: 'पुढे चला',
    numberNotRegistered: 'नंबर नोंदणीकृत नाही',
    numberNotRegisteredMsg: 'तुमचा फोन नंबर नोंदणीकृत नाही. तक्रार नोंदवण्यासाठी प्रथम नोंदणी करा.',
    goToRegistration: 'आमच्यात सामील व्हा',
    tryAnotherNumber: 'दुसरा नंबर वापरा',
    citizenDetails: 'नागरिक तपशील (स्वयंचलित भरलेले)',
    emailAddress: 'ईमेल पत्ता',
    fullAddressLabel: 'पूर्ण पत्ता',
    wardNo: 'वार्ड क्रमांक',
    complaintInfo: 'तक्रार माहिती',
    complaintTitle: 'तक्रारीचे शीर्षक',
    complaintTitlePlaceholder: 'उदा., पाण्याची गळती, रस्त्याचे नुकसान',
    maxChars: 'कमाल 150 अक्षरे',
    complaintDescription: 'तक्रारीचे वर्णन',
    descPlaceholder: 'समस्येचे सविस्तर वर्णन करा...',
    minMaxChars: 'किमान 30, कमाल 3000 अक्षरे',
    priority: 'प्राधान्य',
    medium: 'मध्यम',
    high: 'उच्च',
    low: 'कमी',
    docUpload: 'दस्तऐवज अपलोड (पर्यायी)',
    clickOrDrag: 'फाइल अपलोड करण्यासाठी क्लिक करा किंवा ड्रॅग करा',
    supportedFormats: 'समर्थित: PDF, JPG, PNG (प्रति फाइल कमाल 10MB)',
    submitComplaint: 'तक्रार सादर करा',
    complaintSuccess: 'तक्रार यशस्वीरित्या सादर केली',
    complaintNo: 'तक्रार क्रमांक',
    date: 'तारीख',
    currentStatus: 'सध्याची स्थिती',
    trackComplaintBtn: 'तक्रार ट्रॅक करा',

    // Track Complaint
    trackGrievance: 'तुमची तक्रार ट्रॅक करा',
    trackSubtitle: 'स्थिती तपासण्यासाठी तुमचा नोंदणीकृत मोबाइल नंबर प्रविष्ट करा',
    enterMobile: '10 अंकी मोबाइल नंबर प्रविष्ट करा',
    search: 'शोधा',
    yourComplaints: 'तुमच्या तक्रारी',
    description: 'वर्णन',
    priorityLabel: 'प्राधान्य',
    address: 'पत्ता',
    attachments: 'संलग्नके',
    viewFile: 'फाइल पहा',
    department: 'विभाग',
    notAssigned: 'नियुक्त नाही',
    statusTimeline: 'स्थिती कालरेषा',
    complaintDetails: 'तक्रार तपशील',
    noComplaints: 'या मोबाइल नंबरसाठी कोणतीही तक्रार आढळली नाही.',

    // Footer
    footerDesc: 'नागरिक नोंदणी व व्यवस्थापन प्रणाली. सुरक्षित. स्केलेबल. सरकारी दर्जाची.',
    quickLinks: 'त्वरित दुवे',
    support: 'सहाय्य',
    supportDesc: 'तांत्रिक सहाय्यासाठी, तुमच्या जिल्हा प्रशासकाशी संपर्क साधा.',
    footerCopy: '© {year} पुणे प्रथम. सर्व हक्क राखीव. | महापौरांचा उपक्रम',

    // Accessibility Panel
    accessibilityOptions: 'प्रवेशयोग्यता पर्याय',
    biggerText: 'मोठा मजकूर',
    smallerText: 'लहान मजकूर',
    textSpacing: 'मजकूर अंतर',
    lineHeight: 'ओळींची उंची',
    dyslexiaFriendly: 'डिस्लेक्सिया अनुकूल',
    adhdMode: 'ADHD मोड',
    saturation: 'संपृक्तता',
    lightDark: 'प्रकाश-अंधार',
    invertColors: 'रंग उलटवा',
    highlightLinks: 'दुवे हायलाइट करा',
    textToSpeech: 'मजकूर ते वाणी',
    screenReader: 'स्क्रीन रीडर',
    cursor: 'कर्सर',
    pauseAnimation: 'अॅनिमेशन थांबवा',
    hideImages: 'प्रतिमा लपवा',
    resetAllSettings: 'सर्व सेटिंग्ज रीसेट करा',
    createdBy: 'पुणे प्रथम द्वारे निर्मित',
  },
} as const

export type TranslationKey = keyof typeof translations.en
